export default "__VITE_ASSET__e16811ae__"